import * as React from 'react';
import {
  DataGrid,
} from '@mui/x-data-grid';

import api from "../../services/api";
import {
  Paper,
  Typography,
  Container,
  Button
} from '@mui/material';
import Grid from "@mui/material/Grid2";
import { useStoreActions } from 'easy-peasy';
import { CSVDownload } from 'react-csv';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

const AdminUsuariosEmpresas = () => {

  let startLoading = useStoreActions((actions) => actions.nav.startLoading);
  let stopLoading = useStoreActions((actions) => actions.nav.stopLoading);


  const [rows, setRows] = React.useState([]);
  const [csvData, setCsvData] = React.useState([]);
  const [shouldDownload, setShouldDownload] = React.useState(false);

  const columns = React.useMemo(
    () => [{
      field: 'email',
      headerName: 'E-mail',
      flex: 2,
    },{
      field: 'temas',
      headerName: 'Temas',
      flex: 2,
    },{
      field: 'empresa',
      headerName: 'Empresas',
      flex: 2,
    }]
  );

  const loadUsersEmpresas = async (mount) => {
    startLoading();
    try {
        let response = await api.http.get('/users-empresas');
        let data = response.data.map((item, index) => {
          return {
            id: index,
            ...item
          };
        });
      if (mount.isMounted)
        setRows(data);
      stopLoading();
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
    };
  };

  React.useEffect(()=> {
    let mount = {
        isMounted: true
      };
      loadUsersEmpresas(mount);
      return () => {
        mount.isMounted = false;
      };

  },[]);

function handleExport (){
  if (rows && rows.length > 0) {
    const exportData = rows.map((dados) => {
      return {
        Email: dados.email,
        Temas: dados.temas,
        Empresa: dados.empresa,
      };
    });
    setCsvData(exportData);
    setShouldDownload(true);
  }
}
React.useEffect(() => {
  if (shouldDownload) {
    setShouldDownload(false);
  }
}, [shouldDownload]);

  return (
    (<Container maxWidth="false">
      <Grid container spacing={3} sx={{'my': 2}}>
        <Grid style={{'textAlign': 'left'}} size="grow">
          <Typography variant="h4">Usuários e Empresas</Typography>
        </Grid>
        <Grid style={{'textAlign': 'right'}} size="grow">
        <Button
          variant="contained"
          onClick={handleExport}
          sx={{height:45}}
        >
          <FileDownloadIcon /> Exportar Dados (CSV)
        </Button>
        {shouldDownload && csvData.length > 0 && (
            <CSVDownload data={csvData} separator=";" target="_blank" />
          )}
        </Grid>
      </Grid>
      <Paper variant="elevation" elevation={2}
             style={{
               height: 700, width: '100%'
             }} >
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={25}
          rowsPerPageOptions={[25]}
          disableSelectionOnClick
        />
      </Paper>
    </Container>)
  );
};

export default AdminUsuariosEmpresas;
